import classNames from "classnames";
import React from "react";
import { DashboardView } from "../../../../__generated__/api";
import { useTicketState } from "../../../../contexts/ticket-state";
import Styles from "./ColumnGroup.module.scss";
import { ReactComponent as EmptyFolderIcon } from "../../../../assets/icons/empty-folder.svg";

export default function ColumnGroupEmpty() {
    const ticketContext = useTicketState();

    const view = ticketContext.currentDashboard.settings?.view ?? DashboardView.Kanban;

    return (
        <div className={classNames(
            Styles["column-group"],
            Styles[`column-group-${view?.toLowerCase()}`],
            Styles["column-group-empty"],
        )}
        >
            <div className={Styles["column-group-empty-icon"]}>
                <EmptyFolderIcon />
            </div>
            {" "}
            Empty
        </div>
    );
}
